import { render } from "./OSListRow.vue?vue&type=template&id=69705fb7&scoped=true"
import script from "./OSListRow.vue?vue&type=script&lang=js"
export * from "./OSListRow.vue?vue&type=script&lang=js"

import "./OSListRow.vue?vue&type=style&index=0&id=69705fb7&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69705fb7"]])

export default __exports__